import { Stack, Typography } from '@mui/material';
import { useMyAssortmentTFunction } from '@retail/my-assortment/i18n';
import { SupplierItemAssortmentTag } from '@retail/products/types';
import { getLLDate } from '@retail/utils';

interface Props {
  assortmentTag: SupplierItemAssortmentTag;
}

export function AssortmentTagTooltipInfo({ assortmentTag }: Props) {
  const t = useMyAssortmentTFunction();

  return (
    <Stack flexDirection="row" alignItems="center" gap={2}>
      <Stack gap={1}>
        <Typography variant="body2">{t('myAssortment.columns.name')}:</Typography>
        <Typography variant="body2">{t('myAssortment.columns.validFrom')}:</Typography>
        <Typography variant="body2">{t('myAssortment.columns.validTo')}:</Typography>
      </Stack>

      <Stack gap={1}>
        <Typography variant="subtitle2">{assortmentTag.tagName}</Typography>
        <Typography variant="subtitle2">{getLLDate(assortmentTag.validFrom)}</Typography>
        <Typography variant="subtitle2">{getLLDate(assortmentTag.validTo) ?? '-'}</Typography>
      </Stack>
    </Stack>
  );
}
